<template>
  <main>
    <Notifications
      position="top center"
      class="app-push-notification"
    />
    <RouterView />
  </main>
</template>
